/**
 * AuthModal - a Dialog wrapper around the shared AuthForm offering both Sign In
 * and Sign Up in one place. Driven by the AuthModalProvider; not used directly.
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  useTheme,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import AuthForm from './AuthForm';

const AuthModal = ({ open, onClose, initialMode = 'login', title, subtitle, onSuccess }) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth keepMounted={false}>
      <DialogTitle
        sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, pb: 1 }}
      >
        <Box>
          <Typography
            variant="h5"
            sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700, color: theme.palette.primary.main }}
          >
            {title || 'Welcome to Royal Dastinos'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle || 'Sign in or create an account to continue'}
          </Typography>
        </Box>
        <IconButton onClick={onClose} aria-label="close" edge="end" sx={{ mt: -0.5 }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <AuthForm initialMode={initialMode} showToggle onSuccess={onSuccess} />
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
